import React, {useEffect, useState} from 'react';
import Request from "../../../components/api/Request";
import {DevGrid} from "../../../components/devx";
import {Column, Editing, Form, Popup, Position, ToolbarItem} from "devextreme-react/data-grid";
import TextBox from 'devextreme-react/text-box';
import {Button} from "devextreme-react";
import {showToast} from "../../../utils/Utils";
import {ToastType} from "../../../constants/Constants";

const RolKullaniciGrup = () => {
    const listeBasligi = "Rol Kullanıcı Tanımları";
    const [liste, setListe] = useState([]);
    const [kullanici, setKullanici] = useState(null);
    const [username, setUsername] = useState("");


    useEffect(() => {
        if (kullanici != null) {
            const request = new Request('/roleUserGroup/getKayitList?filter=[{"property":"user.id","operator":"=","value":' + kullanici.id + ',"type":"Long"}]', "GET");
            request.run()
                .then(response => {
                    if (response.data) {
                        setListe(response.data.data);
                    } else {
                        setListe([]);
                    }
                }).catch(() => {
                setListe([]);
            });
        } else {
            setListe([]);
        }
    }, [kullanici])


    const usernameChange = (e) => {
        setUsername(e.value);
    }


    const sorgula = (e) => {
        if (username.length > 0) {
            const request = new Request('/kullanici/getKullaniciByUsername/' + username, "GET");
            request.run()
                .then(response => {
                    if (response.data) {
                        setKullanici(response.data.data);
                    } else {
                        setKullanici(null);
                    }
                }).catch(() => {
                setKullanici(null);
            });
        } else {
            showToast('Kullanıcı adı dolu olmalıdır.', ToastType.ERROR, 1000);
        }
    }


    return <React.Fragment>
        <h2 className='dx-icon-product'>{listeBasligi}</h2>
        <div className="dx-field">
            <form onSubmit={sorgula}>
                <TextBox defaultValue=""
                         value={username}
                         showClearButton={true}
                         placeholder="Kullanıcı adı giriniz. (Sorgulamak için Enter)"
                         valueChangeEvent="keyup"
                         onValueChanged={usernameChange}/>
            </form>
        </div>
        <Button icon="refresh" width={150} text="Sorgula" type={'success'} style={{fontSize: "15px"}}
                onClick={sorgula}></Button>
        {kullanici != null ? <h4 style={{color: 'red'}}>Aktif kullanıcı: {kullanici.username}</h4> : null}
        <DevGrid key={"id"} dataSource={liste} remoteOperations={true}>

            <Column dataField={'id'} width={90} caption={'Id'} dataType="number" fixed={true} visible={true}/>
            <Column dataField={'modulId'} width={90} caption={'ModuleId'} dataType="string" fixed={true} visible={true}/>
            <Column dataField={'modulName'} width={90} caption={'Modül Adı'} dataType="string" fixed={true} visible={true}/>
            <Column dataField={'roleId'} width={90} caption={'RolId'} dataType="string" fixed={true} visible={true}/>
            <Column dataField={'roleName'} width={90} caption={'Rol'} dataType="string" fixed={true} visible={true}/>
        </DevGrid>


    </React.Fragment>
}

export default RolKullaniciGrup;
